import { render } from "./ModalStatic.vue?vue&type=template&id=9ff98266"
import script from "./ModalStatic.vue?vue&type=script&lang=js"
export * from "./ModalStatic.vue?vue&type=script&lang=js"

import "./ModalStatic.vue?vue&type=style&index=0&id=9ff98266&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__